import { useEffect, useState } from 'react'
import '../styles/Hero.css'

// Local static background images - faster loading than database
const backgroundImages = [
  '/images/backgrounds/mixer-bg.jpg',
  '/images/backgrounds/mixer2-bg.jpg',
  '/images/backgrounds/mixer3-bg.jpg',
  '/images/backgrounds/tll1-bg.jpg',
  '/images/backgrounds/tll2-bg.jpg',
  '/images/backgrounds/tll3-bg.jpg'
]

const Hero = () => {
  const [bgLoaded, setBgLoaded] = useState(false)
  const [selectedBg, setSelectedBg] = useState('')

  useEffect(() => {
    const loadBackgroundImage = () => {
      // Randomly select a local background image
      const randomIndex = Math.floor(Math.random() * backgroundImages.length)
      const selectedImage = backgroundImages[randomIndex]
      setSelectedBg(selectedImage)

      // Preload the image
      const img = new Image()
      img.src = selectedImage
      img.onload = () => setBgLoaded(true)
      img.onerror = () => {
        console.warn('Hero background image failed to load, trying another')
        // Try another image if this one fails
        const nextIndex = (randomIndex + 1) % backgroundImages.length
        const nextImage = backgroundImages[nextIndex]
        setSelectedBg(nextImage)
        const nextImg = new Image()
        nextImg.src = nextImage
        nextImg.onload = () => setBgLoaded(true)
      }
    }

    loadBackgroundImage()
  }, [])

  return (
    <div 
      id="hero" 
      className={`hero ${bgLoaded ? 'bg-loaded' : 'bg-loading'}`}
      style={bgLoaded ? { backgroundImage: `url(${selectedBg})` } : {}}
    >
      <div className="hero-content">
        <div className="hero-logo">
          <img src="/images/thelostloft-logo-tagline-transparent.png" alt="The Lost Loft - Chicago's Best Kept Secret in Underground House and Techno" />
        </div>
      </div>
      <div className="hero-overlay"></div>
    </div>
  )
}

export default Hero
